import React from "react";
import { Dialog, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getPhotoUrl } from "utils";
import moment from "moment";

const PhotoPreviewDialog = ({
  open,
  photos = [],
  photoIndex = 0,
  onClose,
  onPrev,
  onNext,
}) => {
  const currentPhoto = photos[photoIndex] || {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      // PackageEditDialog (and other dialogs that open this as a nested photo
      // viewer) force their own zIndex above theme.zIndex.modal, so this needs
      // to go even higher or it renders behind the parent dialog's paper.
      sx={{ zIndex: (theme) => theme.zIndex.modal + 20 }}
      PaperProps={{
        style: {
          background: "rgba(0,0,0,0.9)",
          margin: 0,
          width: "100vw",
          height: "100vh",
          maxWidth: "100vw",
          maxHeight: "100vh",
          borderRadius: 0,
          boxShadow: "none",
          overflow: "hidden",
        }
      }}
    >
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100vw"
        height="100vh"
        m={0}
        p={0}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute", top: 25, right: 25, color: "#fff",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)", // Add shadow
            backgroundColor: "rgba(0, 0, 0, 0.2)", // Optional: add background
            zIndex: 2
          }}
          aria-label="Close"
        >
          <CloseIcon />
        </IconButton>
        {photos.length > 1 && (
          <>
            <IconButton
              onClick={onPrev}
              sx={{ position: "absolute", left: 40, color: "#fff", zIndex: 2 }}
              aria-label="Previous"
            >
              <ArrowBackIosNewIcon />
            </IconButton>
            <IconButton
              onClick={onNext}
              sx={{ position: "absolute", right: 40, color: "#fff", zIndex: 2 }}
              aria-label="Next"
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </>
        )}
        <Box
          component="img"
          src={getPhotoUrl(currentPhoto)}
          alt={`photo-full-${photoIndex}`}
          sx={{
            width: "100vw",
            height: "100vh",
            objectFit: "scale-down",
            borderRadius: 0,
            boxShadow: 0,
            margin: 0,
            p: 0,
            background: "transparent"
          }}
        />
        {/* Show timestamp and Google Maps link if available */}
        {typeof currentPhoto === "object" && currentPhoto?.timestamp && (
          <Box sx={{
            position: "absolute",
            bottom: "10%",
            left: 0,
            width: "100%",
            textAlign: "center",
            color: "#fff",
            background: "rgba(0,0,0,0.4)",
            py: 0.5,
            borderRadius: 1
          }}>
            <Typography variant="body2" color="#fff">
              {/* {typeof currentPhoto.timestamp === "string"
                ? currentPhoto.timestamp
                : new Date(currentPhoto.timestamp).toLocaleString()} */}
              {currentPhoto?.timestamp ? "Date: " + moment(currentPhoto.timestamp).format("DD/MM/YYYY HH:mm:ss") : null}
            </Typography>
            {currentPhoto.lat && currentPhoto.lng && (
              <a
                href={`https://maps.google.com/?q=${currentPhoto.lat},${currentPhoto.lng}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#90caf9", fontSize: 14, textDecoration: "underline" }}
              >
                View on Google Maps
              </a>
            )}
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default PhotoPreviewDialog;